import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function Summary() {
  const location = useLocation();
  const navigate = useNavigate();
  const paymentData = location.state || {};

  function formatCurrency(value) {
    if (!value && value !== 0) return 'GHS 0';
    const num = Number(String(value).replace(/[^\d.]/g, ''));
    if (isNaN(num)) return `GHS ${value}`;
    return `GHS ${num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }

  return (
    <div style={{ minHeight: '80vh', background: '#f5f6fa', padding: 24, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 32 }}>
      <div style={{ width: '100%', maxWidth: 600 }}>
        <div style={{ background: '#fff', borderRadius: 18, boxShadow: '0 4px 24px 0 rgba(0,0,0,0.10)', padding: '32px 24px', display: 'flex', flexDirection: 'column', gap: 24 }}>
          <h1 style={{ fontSize: '24px', fontWeight: '800', color: '#000', marginBottom: '12px' }}>Payment Summary</h1>
          <p style={{ fontSize: '16px', color: '#666', marginBottom: 16 }}>Review your payment details before proceeding.</p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {Array.isArray(paymentData.selectedPremiums) && paymentData.selectedPremiums.length > 0 ? (
              paymentData.selectedPremiums.map((p, idx) => (
                <div key={idx} style={{ background: '#f8f9fa', padding: 16, borderRadius: 12, border: '1px solid #eee' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
                    <div>
                      <div style={{ fontSize: 16, fontWeight: 700 }}>{paymentData.policyName || 'Policy'}</div>
                      <div style={{ fontSize: 14, color: '#666' }}>{paymentData.policyNumber || ''}</div>
                      <div style={{ marginTop: 8, fontSize: 14, color: '#333' }}><strong>Unpaid Month:</strong> {p.month}</div>
                      <div style={{ marginTop: 6, fontSize: 14, color: '#333' }}><strong>Unpaid Reason:</strong> {p.reason}</div>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <div style={{ fontSize: 16, fontWeight: 700 }}>{formatCurrency(p.amount)}</div>
                      <div style={{ fontSize: 13, color: '#666', marginTop: 8 }}><strong>Payment Method:</strong> {paymentData.paymentMethod || 'N/A'}</div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div style={{ fontSize: 16, color: '#666' }}>No months selected</div>
            )}

            <div style={{ fontSize: '16px', color: '#333', marginTop: 4 }}>
              <strong>Payment Type:</strong> {paymentData.paymentType || 'N/A'}
            </div>
            {paymentData.partialAmount && (
              <div style={{ fontSize: '16px', color: '#333', marginBottom: 8 }}>
                <strong>Partial Amount:</strong> {formatCurrency(paymentData.partialAmount)}
              </div>
            )}
            <div style={{ fontSize: '16px', color: '#333', marginBottom: 8 }}>
              <strong>Total:</strong> {formatCurrency(paymentData.total || 0)}
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 24 }}>
            <button
              className="btn btn-primary"
              style={{ padding: '14px 28px', fontSize: '16px', fontWeight: '600', borderRadius: 50 }}
              onClick={() => navigate('/dashboard/payment-processing', { state: paymentData })}
            >
              Proceed to Pay
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Summary;
